import { useState } from "react";
import { Link } from "react-router-dom";

function FormerMemberForm() {
  const [formData, setFormData] = useState({
    name: "",
    discordName: "",
    minecraftUsername: "",
    age: "< 13",
    ruleAbiding: "",
    timeZone: "",
    reasonToJoin: "",
    ruleResponse: "",
    activeHours: "",
  });

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (localStorage.getItem("formSubmitted")) {
      setErrorMessage("You have already submitted a form!");
      setSuccessMessage("");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    try {
      window.scrollTo({ top: 0, behavior: "smooth" });
      await fetch(
        "https://script.google.com/macros/s/AKfycbzzYjaWpklW2pWkNubL_4jVRM6LtaiokfXKydtDcZjV69CDBIo9wRBf2um8TLdJFyl8/exec",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
          mode: "no-cors",
        }
      );

      setSuccessMessage("Form submitted successfully!");
      setErrorMessage("");
      localStorage.setItem("formSubmitted", "true");

      setFormData({
        name: "",
        discordName: "",
        minecraftUsername: "",
        age: "< 13",
        ruleAbiding: "",
        timeZone: "",
        reasonToJoin: "",
        ruleResponse: "",
        activeHours: "",
      });
    } catch (error) {
      setErrorMessage("Error submitting the form.");
    }
  };

  function closeAlert() {
    setSuccessMessage("");
    setErrorMessage("");
  }

  return (
    <div className="">
      <div className="absolute top-14  w-[80%] ml-[10%] z-50">
        {errorMessage && (
          <div className="text-center items-center flex mt-4 text-zinc-200 bg-red-500/90 p-2 rounded-xl">
            <p className="w-[80%] ml-[10%] font-semibold">{errorMessage}</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-6 right-3 absolute hover:bg-red-400/40 rounded-md"
              onClick={closeAlert}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
        )}

        {successMessage && (
          <div className="text-center items-center flex mt-4 text-black bg-green-500/90 p-2 rounded-xl">
            <p className="w-[80%] ml-[10%]">{successMessage}</p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-6 right-3 absolute hover:bg-green-300/40 rounded-md"
              onClick={closeAlert}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
        )}
      </div>
      <div className="bgImg fixed"></div>
      <div className="App text-left">
        <div className="h-38"></div>
        <header className="bg-zinc-900/95 drop-shadow-lg text-zinc-200 top-0 z-10 w-[80%] pb-8 ml-[10%] text rounded-xl">
          <div className="w-[90%] ml-[5%]">
            <div className="text-3xl pt-4 font-semibold">
              Omnicraft SMP Former Member Application
            </div>
            <div className="text-xl mt-4 text-center text-zinc-400">
              BEFORE FILLING OUT AND SUBMITTING THIS APPLICATION PLEASE READ THE
              FOLLOWING:
            </div>
            <div className="text-md mx-[2%] text-center">
              Please make sure you are filling this out as a FORMER MEMBER ONLY.
              If you are a new member you must use{" "}
              <Link to="/new-member-application" className="font-bold">
                THIS FORM
              </Link>{" "}
              to apply as it has specific questions that Administration will be
              looking for during their review. Any former member found
              attempting to circumvent this process will be removed from further
              consideration to this community. All further questions can be
              brought to Owen in the{" "}
              <a
                className="font-bold"
                target="_blank"
                rel="noopener noreferrer"
                href="https://discord.gg/uwcRznrJsp"
              >
                DISCORD
              </a>
              . Filling this form out means you are either a former member that
              has been banned or left for whatever reason.
            </div>
            <div className="text-md mx-[2%] text-center mt-4">
              We expect that you'll put forth your best effort in every response
              as failure to provide adequate information may result in a denied
              application due to lack of effort. Falsifying any answers may
              result in a denial and ban from the Community.
            </div>
          </div>

          <hr className="bg-zinc-400 mx-[3%] my-4"></hr>
          <form onSubmit={handleSubmit} className="w-[90%] ml-[5%]">
            <div className="grid lg:grid-cols-1">
              <div className="">
                <div className="font-extrabold">
                  Applicant Name:{" "}
                  <span className="ml-4 text-xs text-red-600">REQUIRED</span>
                </div>
                <input
                  required
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="bg-zinc-800/75 border-b border-white w-[300px] rounded-t-md text-sm px-1.5 py-1"
                />
                <div className="text-sm font-semibold">
                  Format this as your First Name and Last Initial. (ex: George
                  W.)
                </div>
              </div>

              <div className="mt-4">
                <div className="font-extrabold">
                  Discord Username:{" "}
                  <span className="ml-4 text-xs text-red-600">REQUIRED</span>
                </div>
                <input
                  required
                  name="discordName"
                  value={formData.discordName}
                  onChange={handleChange}
                  className="bg-zinc-800/75 border-b border-white w-[300px] rounded-t-md text-sm px-1.5 py-1"
                />
                <div className="text-sm font-semibold">
                  Ensure this is your discord username, not your display name.
                </div>
              </div>

              <div className="mt-4">
                <div className="font-extrabold">
                  Minecraft Username:{" "}
                  <span className="ml-4 text-xs text-red-600">REQUIRED</span>
                </div>
                <input
                  required
                  name="minecraftUsername"
                  value={formData.minecraftUsername}
                  onChange={handleChange}
                  className="bg-zinc-800/75 border-b border-white w-[300px] rounded-t-md text-sm px-1.5 py-1"
                />
                <div className="text-sm font-semibold">
                  Minecraft gamertag, not your xbox account name.
                </div>
              </div>

              <div className="mt-4">
                <div className="font-extrabold">
                  Age:{" "}
                  <span className="ml-4 text-xs text-red-600">REQUIRED</span>
                </div>
                <select
                  required
                  name="age"
                  value={formData.age}
                  onChange={handleChange}
                  className="bg-zinc-800/75 border-b w-[300px] border-white rounded-t-md text-sm px-1.5 py-1"
                >
                  <option value="< 13">&lt; 13</option>
                  <option value="13-15">13-15</option>
                  <option value="16-18">16-18</option>
                  <option value="18+">18+</option>
                </select>
              </div>

              <div className="mt-4">
                <div className="font-extrabold">
                  What was the reason for your ban (N/A if you were not banned):{" "}
                  <span className="ml-4 text-xs text-red-600">REQUIRED</span>
                </div>
                <textarea
                  required
                  name="ruleAbiding"
                  rows={4}
                  value={formData.ruleAbiding}
                  onChange={handleChange}
                  className="bg-zinc-800/75 border-b border-white w-full rounded-t-md text-sm px-1.5 py-1"
                />
                <div className="text-sm font-semibold">
                  Describe what happened when you were banned. Please be
                  detailed on the events and reasons. Minimum 3-5 sentences.
                </div>
              </div>
              <div className="mt-4">
                <div className="font-extrabold">
                  Why did you leave Omnicraft SMP last time? (N/A if you didnt
                  leave){" "}
                  <span className="ml-4 text-xs text-red-600">REQUIRED</span>
                </div>
                <textarea
                  required
                  rows={4}
                  name="timeZone"
                  value={formData.timeZone}
                  onChange={handleChange}
                  className="bg-zinc-800/75 border-b border-white w-full rounded-t-md text-sm px-1.5 py-1"
                />
                <div className="text-sm font-semibold">
                  State the reason why you left. Minimum 2 sentences.
                </div>
              </div>

              <div className="mt-4">
                <div className="font-extrabold">
                  Why do you want to come back to Omnicraft SMP?{" "}
                  <span className="ml-4 text-xs text-red-600">REQUIRED</span>
                </div>
                <textarea
                  required
                  rows={4}
                  name="reasonToJoin"
                  value={formData.reasonToJoin}
                  onChange={handleChange}
                  className="bg-zinc-800/75 border-b border-white w-full rounded-t-md text-sm px-1.5 py-1"
                />
                <div className="text-sm font-semibold">
                  State the reason you want to rejoin. Also provide any
                  additional information about if you have any projects planned
                  (farms, builds, shops, etc)? Please be specific and detailed,
                  minimum 3-5 sentences.
                </div>
              </div>

              <div className="mt-4">
                <div className="font-extrabold">
                  How many hours can you ACTIVELY play every week?{" "}
                  <span className="ml-4 text-xs text-red-600">REQUIRED</span>
                </div>
                <textarea
                  required
                  rows={4}
                  name="activeHours"
                  value={formData.activeHours}
                  onChange={handleChange}
                  className="bg-zinc-800/75 border-b border-white w-full rounded-t-md text-sm px-1.5 py-1"
                />
                <div className="text-sm font-semibold">
                  Keep your other activities into consideration. Omnicraft
                  requires a minimum of 3+ hours a week of active playtime.
                  AFKing does not count as active play. (Of course we understand
                  that life happens and you may not be able to play as much as
                  you would like, but please be honest with us about your
                  availability.)
                </div>
              </div>

              <div className="mt-4">
                <div className="font-extrabold">
                  What is your Minecraft playstyle?{" "}
                  <span className="ml-4 text-xs text-red-600">REQUIRED</span>
                </div>
                <textarea
                  required
                  rows={4}
                  name="ruleResponse"
                  value={formData.ruleResponse}
                  onChange={handleChange}
                  className="bg-zinc-800/75 border-b border-white w-full rounded-t-md text-sm px-1.5 py-1"
                />
                <div className="text-sm font-semibold">
                  We aim to make Omnicraft enjoyable for everyone by including a
                  carefully curated mix of mods that support many different
                  playstyles, from builders and adventurers to redstone
                  engineers and explorers. Please include details about what you
                  enjoy doing. (Minimum 4 sentences)
                </div>
              </div>
            </div>

            <div className="flex flex-row-reverse mt-4">
              <button
                type="submit"
                className="themeBg hover:bg-gray-700 mx-[5%] text text-xl font-semibold text-zinc-200 py-1.5 px-3 rounded-3xl flex"
              >
                <span className="mr-2">Submit Form</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </form>
        </header>
        <div className="h-34"></div>
      </div>
    </div>
  );
}

export default FormerMemberForm;
